import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import CustomizedGrid from '../../../../components/base/Grid/CustomizedGrid';
import Pagination from '../../../../components/base/Pagination/Pagination';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import { Button, Icons } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getFilterData, getPaginationOpts, responseLogWithNotification, useUpdatePeriod,
} from '../../../../utils/utils';
import { WAY_BILL_MODULE } from '../../../../configs/moduleNames';
import { getSystemData } from '../../../System/reducer';
import wayBillColumns from '../../../Waybill/components/wayBillColumns';
import { getWayBillData } from '../../../Waybill/reducer';
import { loadWayBill } from '../../../Waybill/actions';
import FilterRow from '../../../../components/base/FilterRow/FilterRow';
import { addGlobalPopUpWrapper } from '../../../InformationScreenWrapper/actions';
import { POPUP_LIST_NAME } from '../../../../configs';
import getDefaultSort from '../../../../utils/getDefaultSort';
import { PAGE_TYPE } from '../../../FilterTemplate/components/filter-settings';
import FilterModal from '../../../FilterTemplate/components/FilterModal';
import TimerLoader from '../../../../components/base/Loader/TimerLoader';

export function WayBillBox(props) {
  const { driver_id, onClose = () => {} } = props;
  const dispatch = useDispatch();
  const {
    loadingWayBillList,
    wayBillList = [],
    wayBillListMeta,
  } = useSelector(getWayBillData);
  const store = useStore();
  const {
    formatMessage,
  } = intlShape;
  const [isOpenFilter, setOpenFilter] = useState(false);
  const {
    getValues, control, watch, setValue, reset,
  } = useForm({
    defaultValues: getFilterData('driver-waybill-filter', {}),
    resetOptions: {
      keepValues: false,
      keepDirtyValues: false,
      keepDefaultValues: false,
    },
  });
  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem('driver-waybill-filter', JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[WAY_BILL_MODULE].transportListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { driver_id, ...getValues() },
      sort,
    };
    const p1 = dispatch(loadWayBill(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  useEffect(() => reset(getFilterData('driver-waybill-filter', {})), []);

  const { updatePeriod } = useSelector(getSystemData);
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  const [sort, setSort] = useState(getDefaultSort(wayBillColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  useEffect(() => { loadData(); }, [sort]);

  const moreFormatter = (_, item) => (
    <Icons customIcon icon="more-vert" className="more-vert" />
  );

  return (
    <div className="dlc-body flex-column">
      <TimerLoader loading={loadingWayBillList} />
      <div className="dlc-title">
        <Icons width={24} height={24} customIcon icon="arrow-return" onClick={onClose} />
        <div className="f3">{formatMessage({ id: 'driver.card.menu.sheets' })}</div>
        <FilterRow>
          <Button
            variant="second"
            className=""
            onClick={() => {
              setOpenFilter(true);
            }}
          >
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={{}}
                page={PAGE_TYPE.WAYBILL}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="grid-wrapper frame">
        <div className="custom-scroll-theme sticky-table-wrapper custom">
          <CustomizedGrid
            data={wayBillList}
            onDoubleClickByRow={item => {
              dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.WAY_BILL_DETAIL, id: item.id })));
            }}
            columns={wayBillColumns}
            additionalColumns={[]}
            name="driver-waybill-list"
            settingsFormatter={moreFormatter}
            changeSort={changeSort}
            sort={sort}
            rowClassFormatter={rowClassFormatter}
          />
        </div>
        <Pagination meta={wayBillListMeta} list={wayBillList} handleChangeMeta={loadData} />
      </div>
    </div>
  );
}
